"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casola-in-lunigiana": {
    "8237330c": [{
      "hkey": "2a8e72f0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "casola": [{
      "hkey": "2a8e72f0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e58c0eb5": [{
      "hkey": "1847f448",
      "slug": "casola-in-lunigiana",
      "name": "Casola in Lunigiana",
      "primary": true,
      "skipSearch": false
    }],
    "equi-terme": [{
      "hkey": "1847f448",
      "slug": "casola-in-lunigiana",
      "name": "Casola in Lunigiana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;